import AboutPopin from "./AboutPopin";

// Export without redux connection
export default AboutPopin;
